import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Drawer, TextField, Typography, Chip } from '@material-ui/core';
import { BranchMultiSelect, DeviceMultiSelect, QrMultiSelect } from '../../../../components';
import CloseIcon from '@material-ui/icons/Close';
import {
  ChargeBranchChipChange,
  ChargeDeviceChipChange,
  ChargeQrChipChange,
  ChargeStartAmountChange,
  ChargeEndAmountChange,
  ChargeStatusChange,
  GetMockCharge,
  GetCharge
} from 'store/actions';
import { CHARGE_STATUS } from 'services/constants';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import moment from 'moment';

const Filter = props => {
  const { openFilter, onClose, openCalendar } = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const charge = useSelector(({ charge }) => charge);
  const branchs = useSelector(({ branch }) => branch.branchs);
  const devices = useSelector(({ device }) => device.devices);
  const qrtypes = useSelector(({ qr }) => qr.qrtypes);
  const status = useSelector(({ charge }) => charge.status);

  const handleBranchChipDelete = id => {
    let newValue = [...charge.branchChips];
    if (newValue.length !== 1) {
      newValue = newValue.filter(item => item.id !== id);
      dispatch(ChargeBranchChipChange(newValue));
    }
  };

  const handleBranchMultiSelectChange = value => {
    if (value.length !== 0) {
      dispatch(ChargeBranchChipChange(value));
    }
  };

  const handleDeviceChipDelete = id => {
    let newValue = [...charge.deviceChips];
    if (newValue.length !== 1) {
      newValue = newValue.filter(item => item.id !== id);
      dispatch(ChargeDeviceChipChange(newValue));
    }
  };

  const handleDeviceMultiSelectChange = value => {
    if (value.length !== 0) {
      dispatch(ChargeDeviceChipChange(value));
    }
  };

  const handleQrChipDelete = id => {
    let newValue = [...charge.qrChips];
    if (newValue.length !== 1) {
      newValue = newValue.filter(item => item.id !== id);
      dispatch(ChargeQrChipChange(newValue));
    }
  };

  const handleQrMultiSelectChange = value => {
    if (value.length !== 0) {
      dispatch(ChargeQrChipChange(value));
    }
  };

  const handleSubmit = () => {
    // dispatch(GetCharge());
    dispatch(GetMockCharge());
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={openFilter}
      variant="temporary"
    >
      <div className={classes.root}>
        <div className={classes.header}>
          <Button
            onClick={onClose}
            size="small"
          >
            <CloseIcon className={classes.buttonIcon} />
                        Close
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.contentSection}>
            <div className={classes.contentSectionHeader}>
              <Typography variant="h5">Charge filter</Typography>
            </div>
            <div className={classes.contentSectionContent}>
              {/* Branch */}
              <div className={classes.chips}>
                {charge.branchChips.map(item => (
                  <Chip
                    className={classes.chip}
                    color="primary"
                    deleteIcon={<CloseIcon />}
                    key={item.id}
                    label={item.branchName}
                    onDelete={() => handleBranchChipDelete(item.id)}
                    variant="outlined"
                  />
                ))}
              </div>

              <div className={classes.selects}>
                {branchs && (
                  <BranchMultiSelect
                    key="Branchs"
                    label="Select branch"
                    onChange={handleBranchMultiSelectChange}
                    options={branchs}
                    value={charge.branchChips}
                  />
                )}
              </div>

              {/*Device*/}
              <div className={classes.chips}>
                {charge.deviceChips.map(item => (
                  <Chip
                    className={classes.chip}
                    color="primary"
                    deleteIcon={<CloseIcon />}
                    key={item.id}
                    label={item.deviceName}
                    onDelete={() => handleDeviceChipDelete(item.id)}
                    variant="outlined"
                  />
                ))}
              </div>

              <div className={classes.selects}>
                {devices && (
                  <DeviceMultiSelect
                    key="Devices"
                    label="Select device"
                    onChange={handleDeviceMultiSelectChange}
                    options={devices}
                    value={charge.deviceChips}
                  />
                )}
              </div>

              {/* QrType */}
              <div className={classes.chips}>
                {charge.qrChips.map(item => (
                  <Chip
                    className={classes.chip}
                    color="primary"
                    deleteIcon={<CloseIcon />}
                    key={item.id}
                    label={item.qrName}
                    onDelete={() => handleQrChipDelete(item.id)}
                    variant="outlined"
                  />
                ))}
              </div>

              <div className={classes.selects}>
                {qrtypes && (
                  <QrMultiSelect
                    key="QrTypes"
                    label="Select qr"
                    onChange={handleQrMultiSelectChange}
                    options={qrtypes}
                    value={charge.qrChips}
                  />
                )}
              </div>

              {/* Date */}
              <div className={classes.formGroup}>
                <div className={classes.fieldGroup}>
                  <TextField
                    className={classes.field}
                    label="Start date"
                    margin="dense"
                    name="Startdate"
                    onClick={() => openCalendar('start')}
                    value={moment(charge.startDate).format('DD-MM-YYYY')}
                    variant="outlined"
                  />
                  <Typography
                    style={{ width: 32 }}
                    variant="body1"
                  />
                  <TextField
                    className={classes.field}
                    label="End date"
                    margin="dense"
                    name="Enddate"
                    onClick={() => openCalendar('end')}
                    value={moment(charge.endDate).format('DD-MM-YYYY')}
                    variant="outlined"
                  />
                </div>
              </div>

              <div className={classes.formGroup}>
                <div className={classes.fieldGroup}>
                  <TextField
                    className={classes.field}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ min: '0', max: '1000000', step: '1' }}
                                        label="Start amount"
                                        margin="dense"
                                        name="From"
                                        onChange={e =>
                                            dispatch(ChargeStartAmountChange(e.target.value))
                                        }
                                        placeholder="0"
                                        style={{ flex: 2 }}
                                        type="number"
                                        value={charge.startAmount}
                                        variant="outlined"
                  />
                  <Typography
                    style={{ width: 32, textAlign: 'center' }}
                    variant="body1"
                  >
                    {/* To */}
                  </Typography>
                  <TextField
                    className={classes.field}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ min: '0', max: '1000000', step: '1' }}
                                        label="End amount"
                                        margin="dense"
                                        name="To"
                                        onChange={e =>
                                            dispatch(ChargeEndAmountChange(e.target.value))
                                        }
                                        placeholder="0"
                                        style={{ flex: 2 }}
                                        type="number"
                                        value={charge.endAmount}
                                        variant="outlined"
                  />
                </div>
              </div>
              {/* Status */}
              <div className={classes.formGroup}>
                <TextField
                  className={classes.field}
                  fullWidth
                  label="Status"
                  margin="dense"
                  name="Status"
                  onChange={event => {
                    dispatch(ChargeStatusChange(event.target.value));
                  }}
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={status}
                  variant="outlined"
                >
                  {CHARGE_STATUS.map(status => (
                    <option
                      key={status.id}
                      value={status.id}
                    >
                      {status.name}
                    </option>
                  ))}
                </TextField>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.actions}>
          <Button
            color="primary"
            fullWidth
            onClick={() => handleSubmit()}
            type="submit"
            variant="contained"
          >
                        Apply filters
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

Filter.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  openFilter: PropTypes.bool.isRequired
};

export default Filter;

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(0, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  chips: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'left',
    flexWrap: 'wrap'
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  selects: {
    paddingBottom: theme.spacing(2)
  }
}));
